module.exports = __webpack_public_path__ + "static/media/personal_pronoun_1st_img.fb2454a4.JPG";